import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

@Component({
  selector: 'ch-search-input',
  templateUrl: './search-input.component.html',
  styleUrls: ['./search-input.component.css'],
})
export class SearchInputComponent implements OnInit {
  @Input() public value: string;
  @Output() public search: EventEmitter<any> = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  public submit(value) {
    this.search.emit(value);
  }
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/core/search-input/search-input.component.ts